import { r as registerTranslation, t as translation, a as translation$1, F as FormControl, _ as __decorate, b as __metadata, c as FormControlController } from '../en-Bj2vADBP.js';
import { css, nothing, html } from 'lit';
import { query, property, state, customElement } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import 'lit/directive.js';

var styles = css`@charset "UTF-8";
*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: hsla(0, 0%, 0%, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

p {
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: var(--bsi-spacing-s);
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: var(--bsi-spacing-l);
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: var(--bsi-spacing-s);
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: var(--bsi-font-weight-strong);
}

dd {
  margin-bottom: var(--bsi-spacing-xxs);
  margin-left: 0;
}

blockquote {
  margin: 0 0 var(--bsi-spacing-s);
}

sub,
sup {
  position: relative;
  font-size: var(--bsi-font-size-1);
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--bsi-color-link);
  text-decoration: underline;
  text-decoration-skip-ink: auto;
  text-underline-offset: 2px;
}
a:hover {
  color: var(--bsi-color-link-hover);
  cursor: pointer;
}

pre,
code,
kbd,
samp {
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
  overflow: auto;
}
pre code {
  word-break: normal;
}

a > code {
  color: inherit;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: hsl(210, 17%, 44%);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.avatar {
  --bsi-avatar-background: var(--bsi-color-background-secondary-lighter);
  --bsi-avatar-dot-border-color: var(--bsi-color-border-inverse);
  --bsi-avatar-dot-border-size: 2px;
  --bsi-avatar-dot-offset-bottom: 0;
  --bsi-avatar-dot-offset-right: 0;
  --bsi-avatar-dot-offset-top: 4px;
  --bsi-avatar-dot-size: 12px;
  --bsi-avatar-font-size: var(--bsi-font-size-3);
  --bsi-avatar-font-weight: var(--bsi-font-weight-solid);
  --bsi-avatar-icon-size: var(--bsi-icon-size-s);
  --bsi-avatar-overlay-background: var(--bsi-color-background-emphasis);
  --bsi-avatar-radius: var(--bsi-radius-circle);
  --bsi-avatar-size: 2.5rem;
  --bsi-avatar-text-color: var(--bsi-color-text-secondary);
  --bsi-avatar-dropdown-margin-left: -24px;
  --bsi-avatar-dropdown-margin-top: 24px;
}

/* stylelint-disable-next-line no-duplicate-selectors */
.avatar {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--bsi-avatar-size);
  height: var(--bsi-avatar-size);
  border-radius: var(--bsi-avatar-radius);
  background: var(--bsi-avatar-background);
  color: var(--bsi-avatar-text-color);
  transition: background-color var(--bsi-transition-instant);
}
.avatar.avatar-primary {
  --bsi-avatar-background: var(--bsi-theme-primary);
  --bsi-avatar-text-color: var(--bsi-color-text-inverse);
}
.avatar.avatar-secondary {
  --bsi-avatar-background: var(--bsi-color-background-secondary);
  --bsi-avatar-text-color: var(--bsi-color-text-inverse);
}
.avatar.size-xs {
  --bsi-avatar-dot-border-size: 1px;
  --bsi-avatar-font-size: 0.625rem;
  --bsi-avatar-size: 1rem;
  --bsi-avatar-icon-size: 0.625rem;
}
.avatar.size-sm {
  --bsi-avatar-dot-border-size: 1px;
  --bsi-avatar-font-size: var(--bsi-font-size-1);
  --bsi-avatar-size: 1.5rem;
  --bsi-avatar-icon-size: var(--bsi-icon-size-xs);
}
.avatar.size-md {
  --bsi-avatar-font-size: var(--bsi-font-size-4);
  --bsi-avatar-size: 2.5rem;
  --bsi-avatar-icon-size: var(--bsi-icon-size-s);
  --bsi-avatar-dot-offset-right: -2px;
}
.avatar.size-lg {
  --bsi-avatar-font-size: var(--bsi-font-size-6);
  --bsi-avatar-size: 3.5rem;
  --bsi-avatar-icon-size: var(--bsi-icon-size-m);
  --bsi-avatar-dot-offset-right: -2px;
  --bsi-avatar-dot-size: 14px;
}
.avatar.size-xl {
  --bsi-avatar-font-size: var(--bsi-font-size-9);
  --bsi-avatar-size: 5rem;
  --bsi-avatar-icon-size: var(--bsi-icon-size-l);
  --bsi-avatar-dot-size: 16px;
}
.avatar.size-xxl {
  --bsi-avatar-font-size: var(--bsi-font-size-11);
  --bsi-avatar-size: 7rem;
  --bsi-avatar-icon-size: var(--bsi-icon-size-xl);
  --bsi-avatar-dot-size: 20px;
  --bsi-avatar-dot-offset-right: 4px;
}
.avatar-wrapper {
  position: relative;
  z-index: 1;
}
.avatar-presence, .avatar-status {
  position: absolute;
  right: var(--bsi-avatar-dot-offset-right);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--bsi-avatar-dot-size);
  height: var(--bsi-avatar-dot-size);
  border: var(--bsi-avatar-dot-border-size) solid var(--bsi-avatar-dot-border-color);
  border-radius: var(--bsi-avatar-radius);
  background: hsl(210, 3%, 85%);
  color: var(--bsi-color-text-inverse);
}
.avatar-presence .icon, .avatar-status .icon {
  stroke-width: 2px;
  stroke: var(--bsi-icon-inverse);
}
.avatar-presence.active, .avatar-status.approved {
  background: var(--bsi-color-background-success);
}
.avatar-presence.busy, .avatar-status.declined {
  background: hsl(350, 60%, 50%);
}
.avatar-presence {
  bottom: 8px;
}
.avatar-presence.hidden:after {
  position: absolute;
  top: 50%;
  left: 50%;
  content: "";
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  border-radius: 50%;
  background: var(--bsi-color-background-inverse);
  transform: translateX(-50%) translateY(-50%);
}
.avatar-status {
  top: var(--bsi-avatar-dot-offset-top);
}
.avatar-status.notify {
  background: var(--bsi-theme-primary);
}
.avatar img {
  width: 100%;
  height: 100%;
  border-radius: var(--bsi-avatar-radius);
  object-fit: cover;
  object-position: center;
}
.avatar p {
  margin: 0;
  color: var(--bsi-avatar-text-color);
  font-size: var(--bsi-avatar-font-size);
  font-weight: var(--bsi-avatar-font-weight);
  line-height: 1;
}
.avatar .icon {
  width: var(--bsi-avatar-icon-size);
  height: var(--bsi-avatar-icon-size);
}
.avatar ~ span {
  margin-left: var(--bsi-spacing-xxs);
}

a.avatar::after,
a .avatar::after {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  border-radius: var(--bsi-avatar-radius);
  opacity: 0;
  background: var(--bsi-color-background-emphasis);
  transition: opacity 0.2s;
}
a.avatar:hover::after,
a .avatar:hover::after {
  opacity: 0.25;
}

a.avatar,
a.avatar:hover,
a.avatar:hover p,
a .avatar:hover,
a .avatar:hover p {
  text-decoration: none;
}

.avatar-dropdown {
  position: relative;
  overflow: visible;
}
.avatar-dropdown .dropdown {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border: 0;
}
.avatar-dropdown .dropdown-menu {
  margin-left: var(--bsi-avatar-dropdown-margin-left) !important;
  margin-top: var(--bsi-avatar-dropdown-margin-top) !important;
}
.avatar-dropdown .btn-dropdown {
  padding: 0;
  color: inherit;
  font-size: var(--bsi-avatar-font-size);
  line-height: 0;
}
.avatar-dropdown .btn-dropdown:focus {
  box-shadow: none;
}
.avatar-dropdown .link-list {
  white-space: nowrap;
}

.avatar-extra-text {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 16px;
}
.avatar-extra-text .avatar {
  flex-shrink: 0;
}
.avatar-extra-text .extra-text {
  margin-left: var(--bsi-spacing-s);
}
.avatar-extra-text .extra-text h3,
.avatar-extra-text .extra-text h4 {
  margin: 0;
  font-size: var(--bsi-heading-6-font-size);
}
.avatar-extra-text .extra-text h3 a,
.avatar-extra-text .extra-text h4 a {
  display: inline-block;
}
.avatar-extra-text .extra-text p,
.avatar-extra-text .extra-text time {
  margin: 0;
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-caption-font-size);
  text-transform: uppercase;
}

.avatar-group > li {
  margin-bottom: var(--bsi-spacing-s);
  display: flex;
}
.avatar-group > li:last-child {
  margin-bottom: 0;
}
.avatar-group > li .list-item {
  padding: 0;
}

.avatar-group-stacked {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
}
.avatar-group-stacked li {
  list-style-type: none;
  line-height: 0;
}
.avatar-group-stacked li > .avatar {
  margin-left: -6px;
  border: 2px solid var(--bsi-color-border-inverse);
}

.upload,
.upload-avatar {
  position: absolute;
  z-index: -1;
  width: 0.1px;
  height: 0.1px;
  overflow: hidden;
  opacity: 0;
}

.upload[type=file] + label {
  display: inline-block;
  margin-bottom: 0;
  max-width: 80%;
  padding: var(--bsi-spacing-xs) var(--bsi-spacing-m);
  overflow: hidden;
  border-radius: var(--bsi-form-control-border-radius);
  background-color: var(--bsi-color-background-primary);
  color: var(--bsi-color-text-inverse);
  font-size: 1rem;
  font-weight: 700;
  transition: background-color var(--bsi-transition-instant);
  cursor: pointer;
}
.upload[type=file] + label:hover {
  background-color: var(--bsi-color-background-primary-hover);
}
.upload[type=file] + label svg {
  margin-right: var(--bsi-spacing-xxs);
  fill: var(--bsi-icon-inverse);
}

.upload-pictures-wall {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}
.upload-pictures-wall > li {
  margin-right: var(--bsi-spacing-xxs);
  margin-bottom: var(--bsi-spacing-xxs);
  list-style-type: none;
}
.upload-pictures-wall > li:last-child {
  margin-right: 0;
}
.upload-pictures-wall .upload[type=file] + label {
  display: table-cell;
  width: 128px;
  height: 128px;
  padding: 0;
  border: 2px dashed var(--bsi-color-border-primary);
  border-radius: 0;
  background-color: var(--bsi-color-border-primary-lighter);
  color: var(--bsi-color-text-primary);
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  transition: border-color var(--bsi-transition-instant);
}
.upload-pictures-wall .upload[type=file] + label .icon {
  display: block;
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  margin: 0 auto;
  fill: var(--bsi-icon-primary);
}
.upload-pictures-wall .upload[type=file] + label:hover {
  border: 2px dashed var(--bsi-color-border-primary-hover);
}
.upload-pictures-wall .upload-image {
  flex-shrink: 0;
  width: 128px;
  height: 128px;
}
.upload-pictures-wall .upload-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-file-list {
  margin-top: 5px;
  padding: 0;
}
.upload-file-list.upload-file-list-image .progress {
  left: 52px;
}
.upload-file-list .upload-file {
  position: relative;
  display: flex;
  align-items: center;
  max-width: 375px;
  margin-bottom: var(--bsi-spacing-s);
  list-style-type: none;
}
.upload-file-list .upload-file.uploading .icon {
  fill: var(--bsi-icon-secondary);
}
.upload-file-list .upload-file.uploading p {
  color: var(--bsi-color-text-secondary);
}
.upload-file-list .upload-file.success svg {
  fill: var(--bsi-icon-success);
}
.upload-file-list .upload-file.success p {
  color: var(--bsi-color-text-success);
}
.upload-file-list .upload-file.success p .upload-file-weight {
  display: inline-block;
}
.upload-file-list .upload-file.error svg {
  fill: var(--bsi-icon-danger);
}
.upload-file-list .upload-file.error p {
  color: var(--bsi-color-text-danger);
}
.upload-file-list .upload-file svg {
  flex-shrink: 0;
}
.upload-file-list .upload-file .upload-image {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
}
.upload-file-list .upload-file .upload-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.upload-file-list .upload-file p {
  margin: 0;
  margin-left: 12px;
  overflow: hidden;
  font-size: 0.875rem;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-file-list .upload-file p .upload-file-weight {
  display: none;
  margin-left: 10px;
  color: var(--bsi-color-text-secondary);
}
.upload-file-list .upload-file button {
  margin-left: auto;
  padding: 0;
  border: 0;
  background: transparent;
}
.upload-file-list .upload-file button:hover {
  cursor: pointer;
}
.upload-file-list .upload-file button:hover svg {
  fill: var(--bsi-icon-primary);
}
.upload-file-list .progress {
  position: absolute;
  bottom: -4px;
  left: 36px;
  width: calc(100% - 45px);
  height: 4px;
  background-color: hsl(210, 3%, 85%);
  box-shadow: none;
}
.upload-file-list .progress.progress-image {
  width: calc(100% - 60px);
}

.upload-avatar-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.upload-avatar-container .upload-avatar[type=file] + label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.upload-avatar-container .upload-avatar[type=file] + label svg {
  display: none;
}
.upload-avatar-container .upload-avatar[type=file] + label span {
  display: none;
}

.avatar-upload {
  overflow: hidden;
}

.avatar-upload-wrapper {
  position: relative;
  display: inline-block;
}
.avatar-upload-wrapper .avatar-upload-icon {
  position: absolute;
  right: 4px;
  bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 2px solid var(--bsi-color-border-inverse);
  border-radius: 50%;
  background: hsl(210, 6.2290689886%, 92.535%);
  pointer-events: none;
  z-index: 1;
}
.avatar-upload-wrapper.size-sm .avatar {
  width: 80px;
  height: 80px;
}
.avatar-upload-wrapper.size-sm .avatar-upload-icon {
  right: 6px;
  bottom: 8px;
  width: 24px;
  height: 24px;
}

.upload-dragdrop {
  display: inline-flex;
  align-items: center;
}
.upload-dragdrop.dragover .upload-dragdrop-image img, .upload-dragdrop.loading .upload-dragdrop-image img {
  transform: translateX(-50%) translateY(-50%) scale(0.85);
}
.upload-dragdrop.loading p:not(.upload-dragdrop-weight) {
  font-style: italic;
}
.upload-dragdrop.loading .upload-dragdrop-loading {
  opacity: 1;
}
.upload-dragdrop.loading .upload-dragdrop-text .upload-dragdrop-weight, .upload-dragdrop.success .upload-dragdrop-text .upload-dragdrop-weight {
  visibility: visible;
}
.upload-dragdrop.success .upload-dragdrop-success {
  opacity: 1;
  transform: scale(1);
}

.upload-dragdrop-text p {
  margin: 0;
  color: var(--bsi-color-text-secondary);
  font-size: 0.875rem;
}
.upload-dragdrop-text p.upload-dragdrop-weight {
  visibility: hidden;
  color: var(--bsi-color-text-secondary);
  font-size: 0.75rem;
}
.upload-dragdrop-text p.upload-dragdrop-weight svg {
  fill: var(--bsi-icon-secondary);
}
.upload-dragdrop-text h5 {
  margin: 0;
  color: var(--bsi-color-text-base);
}

.upload-dragdrop-input {
  position: absolute;
  z-index: -1;
  width: 0.1px;
  height: 0.1px;
  overflow: hidden;
  opacity: 0;
}
.upload-dragdrop-input[type=file] + label {
  color: var(--bsi-color-text-primary);
  text-decoration: underline;
  cursor: pointer;
}
.upload-dragdrop-input:focus[type=file] + label {
  outline: auto 5px -webkit-focus-ring-color;
}

.upload-dragdrop-loading {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 128px;
  height: 128px;
  overflow: hidden;
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.2s;
}
.upload-dragdrop-loading .progress-donut {
  position: relative;
}
.upload-dragdrop-loading .progress-donut .progressbar-text {
  color: #000 !important;
  font-weight: 700;
}
.upload-dragdrop-loading .progress-donut svg {
  position: relative;
}
.upload-dragdrop-loading .progress-donut svg path:first-child {
  display: none;
}
.upload-dragdrop-loading .progress-donut:before {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 0;
  content: "";
  width: 67px;
  height: 67px;
  border-radius: 50%;
  background: #fff;
  transform: translateX(-50%) translateY(-50%);
}

.upload-dragdrop-image {
  position: relative;
  flex-shrink: 0;
  width: 128px;
  height: 128px;
  margin-right: var(--bsi-spacing-s);
}
.upload-dragdrop-image img {
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 50%;
  transform: translateX(-50%) translateY(-50%);
  transform-origin: center center;
  transition: transform 0.4s cubic-bezier(0.33, 1.07, 0.54, 1);
}
.upload-dragdrop-image .upload-dragdrop-success {
  position: absolute;
  top: calc(50% - 18px);
  left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  opacity: 0;
  background: var(--bsi-color-background-success);
  transform: scale(0.6);
  transition: opacity 0.2s, transform 0.5s cubic-bezier(0.75, -0.5, 0, 1.75);
}
.upload-dragdrop-image .upload-dragdrop-success svg {
  width: 30px;
  height: 30px;
  fill: var(--bsi-icon-inverse);
}
.upload-dragdrop-image .upload-dragdrop-success .upload-dragdrop-text h5 + p {
  color: var(--bsi-color-text-success);
  font-weight: var(--bsi-font-weight-solid);
}

@media (min-width: 576px) {
  .upload[type=file] + label {
    font-size: var(--bsi-label-font-size-s);
  }
}
@media (min-width: 768px) {
  .upload-dragdrop-image {
    width: 180px;
    height: 180px;
    margin-right: 32px;
  }
  .upload-dragdrop-image .upload-dragdrop-success {
    left: 28px;
  }
  .upload-dragdrop-loading {
    width: 180px;
    height: 180px;
  }
  .upload-dragdrop-loading .progress-donut:before {
    content: "";
    width: 94px;
    height: 94px;
  }
}
@media (min-width: 1200px) {
  .avatar-upload:hover .upload-avatar-container,
  .avatar-upload:focus-within .upload-avatar-container {
    opacity: 1;
  }
  .upload-avatar-container {
    top: auto;
    right: 0;
    bottom: -10%;
    left: 0;
    width: 100%;
    height: 60%;
    opacity: 0;
    background-color: var(--bsi-overlay-background-primary-muted);
    transition: opacity var(--bsi-transition-instant);
  }
  .upload-avatar-container .upload-avatar[type=file] + label {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    margin: 0;
    padding-top: var(--bsi-spacing-xxs);
    color: var(--bsi-color-text-inverse);
    font-size: 0.75rem;
    text-align: center;
    cursor: pointer;
  }
  .upload-avatar-container .upload-avatar[type=file] + label span {
    display: block;
  }
  .upload-avatar-container .upload-avatar[type=file] + label svg {
    display: block;
    width: 20px;
    height: 20px;
    fill: var(--bsi-icon-inverse);
  }
  .upload-avatar-container .upload-avatar:focus:not([data-focus-mouse=true])[type=file] + label {
    outline: auto 5px -webkit-focus-ring-color;
  }
  .avatar-upload-wrapper .avatar-upload-icon {
    display: none;
  }
  .avatar-upload-wrapper.size-sm .upload-avatar[type=file] + label span {
    display: none;
  }
}
body {
  font-family: var(--bsi-font-sans);
}

p,
ul,
ol,
dl {
  font-size: var(--bsi-body-font-size);
  line-height: var(--bsi-body-leading);
}

caption,
figcaption {
  font-size: var(--bsi-caption-font-size);
  line-height: var(--bsi-caption-leading);
}

b,
strong {
  font-weight: var(--bsi-font-weight-strong);
}

mark,
code {
  padding: 0 var(--bsi-spacing-3xs);
}

mark {
  background-color: var(--bsi-highlight-background);
}

pre,
code,
kbd,
samp {
  border-radius: var(--bsi-radius-smooth);
  font-family: var(--bsi-font-mono);
}

ins,
del {
  position: relative;
  display: flex;
  align-items: center;
  padding: var(--bsi-spacing-3xs) var(--bsi-spacing-m);
  font: var(--bsi-body-font-size);
  text-decoration: none;
}

ins {
  background-color: var(--bsi-ins-background);
  text-decoration: none;
}

del {
  background-color: var(--bsi-del-background);
}

del::before,
ins::before {
  position: absolute;
  left: 0.5rem;
}

del::before {
  content: "−";
}

ins::before {
  content: "+";
}

kbd {
  margin: 0 2px;
  padding: 2px var(--bsi-spacing-3xs);
  border: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
  background-color: var(--bsi-color-background-secondary-lighter);
  box-shadow: var(--bsi-elevation-low), 0 2px 0 0 hsla(255, 0%, 100%, 0.7) inset;
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-font-size-1);
  font-weight: var(--bsi-font-weight-solid);
  white-space: nowrap;
}
kbd kbd {
  padding: 0;
  font-size: var(--bsi-code-font-size);
}

small,
.small {
  font-size: var(--bsi-caption-font-size);
}

.x-small {
  font-size: var(--bsi-font-size-1);
}

h1,
.h1 {
  font-size: var(--bsi-heading-1-font-size);
}

h2,
.h2 {
  font-size: var(--bsi-heading-2-font-size);
}

h3,
.h3 {
  font-size: var(--bsi-heading-3-font-size);
}

h4,
.h4 {
  font-size: var(--bsi-heading-4-font-size);
}

h5,
.h5 {
  font-size: var(--bsi-heading-5-font-size);
}

h6,
.h6 {
  font-size: var(--bsi-heading-6-font-size);
}

h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  margin-top: 0;
  margin-bottom: var(--bsi-heading-spacing);
  line-height: var(--bsi-heading-leading);
}
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h1, p + h1,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h1,
p + .h1,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h2,
p + h2,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h2,
p + .h2,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h3,
p + h3,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h3,
p + .h3,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h4,
p + h4,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h4,
p + .h4,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h5,
p + h5,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h5,
p + .h5,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h6,
p + h6,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h6,
p + .h6 {
  padding-top: var(--bsi-spacing-s);
}

h1,
h2,
h3,
.h1,
.h2,
.h3 {
  font-weight: var(--bsi-heading-font-weight);
}

h4,
h5,
h6,
.h4,
.h5,
.h6 {
  font-weight: var(--bsi-heading-font-weight-weak);
}

h1,
.h1,
.display-1 {
  letter-spacing: -1px;
}

.font-serif {
  font-family: var(--bsi-font-serif) !important;
}

.font-sans-serif {
  font-family: var(--bsi-font-sans) !important;
}

.font-monospace {
  font-family: var(--bsi-font-mono) !important;
}

.display-1 {
  font-size: var(--bsi-display-font-size);
  font-weight: var(--bsi-heading-font-weight);
  line-height: var(--bsi-heading-leading);
}

.lead {
  font-size: var(--bsi-lead-font-size);
  font-weight: var(--bsi-lead-font-weight);
  line-height: var(--bsi-lead-leading);
}

blockquote,
.blockquote {
  margin: var(--bsi-spacing-m) 0;
  margin-left: var(--bsi-spacin-inline-xs);
  padding: var(--bsi-spacing-s);
  border-left: var(--bsi-border-thick) solid var(--bsi-border-color-secondary);
  font-size: var(--bsi-body-font-size);
  line-height: var(--bsi-body-leading);
}
blockquote > :last-child,
.blockquote > :last-child {
  margin-bottom: 0;
}
blockquote.text-end,
.blockquote.text-end {
  margin-right: var(--bsi-spacin-inline-xs);
  border-right: var(--bsi-border-thick) solid var(--bsi-border-color-secondary);
}
blockquote.text-center, blockquote.text-end, blockquote.blockquote-simple,
.blockquote.text-center,
.blockquote.text-end,
.blockquote.blockquote-simple {
  margin-left: 0;
  border-right: none;
  border-left: none;
}
blockquote.text-center, blockquote.blockquote-simple,
.blockquote.text-center,
.blockquote.blockquote-simple {
  padding: 0;
}
blockquote.blockquote-simple,
.blockquote.blockquote-simple {
  font-style: italic;
}
blockquote.blockquote-card,
.blockquote.blockquote-card {
  margin-left: 0;
  padding: var(--bsi-spacing-m);
  background-color: var(--bsi-color-background-inverse);
  box-shadow: var(--bsi-elevation-low);
}
blockquote.blockquote-card .blockquote-footer,
.blockquote.blockquote-card .blockquote-footer {
  font-size: inherit;
}
blockquote.blockquote-card .blockquote-footer:before,
.blockquote.blockquote-card .blockquote-footer:before {
  content: none;
}
blockquote.blockquote-card.dark,
.blockquote.blockquote-card.dark {
  border-left: none;
  background-color: var(--bsi-color-background-primary);
  color: var(--bsi-color-text-inverse);
}
blockquote.blockquote-card.dark .blockquote-footer,
.blockquote.blockquote-card.dark .blockquote-footer {
  color: var(--bsi-color-text-inverse);
}

.blockquote-footer {
  margin-top: 0;
  margin-bottom: var(--bsi-spacing-s);
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-label-font-size);
}
.blockquote-footer::before {
  content: "— ";
}
.bg-dark .blockquote-footer {
  color: var(--bsi-color-text-muted);
}

.initialism {
  font-size: var(--bsi-label-font-size-s);
  text-transform: uppercase;
}

.form-feedback {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.75rem;
}

.input-group-text:has(~ [data-focus-mouse=true]:not(.btn)),
[data-focus-mouse=true]:not(.btn) ~ .input-group-text,
button:has(~ [data-focus-mouse=true]:not(.btn)),
[data-focus-mouse=true]:not(.btn) + button {
  border-color: inherit !important;
  box-shadow: none !important;
  outline: none !important;
}

.input-group-text:has(~ .is-invalid),
.is-invalid ~ .input-group-text,
button:has(~ .is-invalid),
.is-invalid + button {
  border-color: var(--bsi-color-border-danger) !important;
}

.sr-only-justvalidate-bi {
  display: none;
}

.is-valid,
.is-invalid {
  padding-right: calc(1.5em + 0.75rem) !important;
}
.is-valid[type=number],
.is-invalid[type=number] {
  padding-right: calc(1.5em + 0.75rem + var(--bsi-form-control-spacing) + 1rem) !important;
}

.was-validated &:valid,
.is-valid {
  border-color: var(--bsi-color-border-success) !important;
  background-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="%23008055" xmlns="http://www.w3.org/2000/svg"><path d="M9.6,16.9L4,11.4l0.8-0.7l4.8,4.8l8.5-8.4l0.7,0.7L9.6,16.9z" /></svg>');
}
.was-validated &:valid ~ .warning-feedback,
.is-valid ~ .warning-feedback {
  display: block;
}

.was-validated &:invalid,
.is-invalid {
  border-color: var(--bsi-color-border-danger) !important;
  background-image: url('data:image/svg+xml,<svg width="24" fill="%23cc334d" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.7,12l6.7,6.6l-0.8,0.8L12,12.7l-6.6,6.7l-0.8-0.8l6.7-6.6L4.6,5.4l0.8-0.8l6.6,6.7l6.6-6.7l0.8,0.8L12.7,12z" /></svg>');
}

.form-control.warning {
  border-color: var(--bsi-color-border-warning) !important;
  background-image: url('data:image/svg+xml,<svg width="24" height="24" fill="%23995c00" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.5,17h-1V2h1V17z M12.5,20h-1v2h1V20z" /></svg>');
}

.input-group-text:has(~ .is-valid),
.is-valid ~ .input-group-text,
button:has(~ .is-valid),
.is-valid + button {
  border-color: var(--bsi-color-border-success);
}

.is-valid + .input-group-text.align-buttons,
.is-invalid + .input-group-text.align-buttons {
  right: 30px;
}

.is-invalid + .input-group-text.align-buttons {
  bottom: 22px;
}

.autocomplete__wrapper .form-feedback {
  position: absolute;
}

textarea.form-control {
  background-position: top 0.5em right !important;
}

.text-primary {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-primary-rgb), var(--bsi-text-opacity)) !important;
}

.text-secondary {
  --bsi-text-opacity: 1;
  color: hsl(210, 33%, 28%) !important;
}

.text-success {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-success-rgb), var(--bsi-text-opacity)) !important;
}

.text-info {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-info-rgb), var(--bsi-text-opacity)) !important;
}

.text-warning {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-warning-rgb), var(--bsi-text-opacity)) !important;
}

.text-danger {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-danger-rgb), var(--bsi-text-opacity)) !important;
}

.text-light {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-light-rgb), var(--bsi-text-opacity)) !important;
}

.text-dark {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-dark-rgb), var(--bsi-text-opacity)) !important;
}

.text-black {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-black-rgb), var(--bsi-text-opacity)) !important;
}

.text-white {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-white-rgb), var(--bsi-text-opacity)) !important;
}

.text-100 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-100-rgb), var(--bsi-text-opacity)) !important;
}

.text-200 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-200-rgb), var(--bsi-text-opacity)) !important;
}

.text-300 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-300-rgb), var(--bsi-text-opacity)) !important;
}

.text-400 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-400-rgb), var(--bsi-text-opacity)) !important;
}

.text-500 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-500-rgb), var(--bsi-text-opacity)) !important;
}

.text-600 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-600-rgb), var(--bsi-text-opacity)) !important;
}

.text-700 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-700-rgb), var(--bsi-text-opacity)) !important;
}

.text-800 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-800-rgb), var(--bsi-text-opacity)) !important;
}

.text-900 {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-900-rgb), var(--bsi-text-opacity)) !important;
}

.text-body {
  --bsi-text-opacity: 1;
  color: rgba(var(--bsi-body-color-rgb), var(--bsi-text-opacity)) !important;
}

.text-muted {
  --bsi-text-opacity: 1;
  color: hsl(210, 17%, 44%) !important;
}

.text-black-50 {
  --bsi-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bsi-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  --bsi-text-opacity: 1;
  color: inherit !important;
}

:host {
  position: relative;
  display: inline-block;
}

input.upload-avatar {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
}
@media (min-width: 1200px) {
  input.upload-avatar {
    width: 0.1px;
    height: 0.1px;
  }
}

.avatar-upload-wrapper {
  position: relative;
  display: inline-block;
}
@media (min-width: 1200px) {
  .avatar-upload-wrapper {
    overflow: hidden;
  }
}
.avatar-upload-wrapper {
  border-radius: 50%;
  cursor: default;
  line-height: 0;
}
.avatar-upload-wrapper .avatar-upload-icon {
  z-index: 10;
  right: 0;
  bottom: 0px;
  display: flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  isolation: isolate;
}

.it-upload-avatar-label-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.it-upload-avatar-label-container .it-upload-avatar-label {
  font-weight: var(--bsi-font-weight-solid, 600);
}

:host([size=xl]) .it-upload-avatar-label {
  display: none !important;
}
:host([size=xl]) .avatar-upload-wrapper .avatar-upload-icon {
  width: 24px;
  height: 24px;
}

.upload-avatar-container .upload-avatar[type=file] + label it-icon {
  display: none;
}

.avatar-upload-wrapper:focus-within:not(:hover) {
  box-shadow: 0 0 0 2px hsl(0, 0%, 100%), 0 0 0 5px hsl(0, 0%, 0%) !important;
  outline: 3px solid rgba(0, 0, 0, 0) !important;
  outline-offset: 3px !important;
}

@media (min-width: 1200px) {
  .upload-avatar:focus-visible + label {
    box-shadow: 0 0 0 2px hsl(0, 0%, 100%) !important;
    outline: none !important;
  }
  .upload-avatar-container .upload-avatar[type=file] + label {
    padding-top: calc(var(--bsi-spacing-xxs, 8px) / 2);
  }
  :host([size=xl]) .upload-avatar-container .upload-avatar[type=file] + label {
    padding-top: 6px;
  }
  .avatar-upload-wrapper .upload-avatar-container {
    top: auto;
    right: 0;
    bottom: -10%;
    left: 0;
    width: 100%;
    height: 60%;
    background-color: var(--bsi-overlay-background-primary-muted);
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.15s;
  }
  .avatar-upload-wrapper .upload-avatar-container .upload-avatar[type=file] + label it-icon {
    display: block;
  }
  .avatar-upload-wrapper .avatar-upload-icon {
    display: none !important;
  }
  .avatar-upload-wrapper:hover .upload-avatar-container,
  .avatar-upload-wrapper:focus-within .upload-avatar-container {
    z-index: 5;
    opacity: 1;
    transition: opacity 0.25s;
  }
}`;

registerTranslation(translation);
registerTranslation(translation$1);
let ItUploadAvatar = class ItUploadAvatar extends FormControl {
    constructor() {
        super(...arguments);
        // Override the base FormControlController.
        // Value is the selected File, or falls back to the current src (pre-filled image satisfies required).
        this.formControlController = new FormControlController(this, {
            value: (el) => el._currentFile ?? (el._currentSrc || null),
            assumeInteractionOn: ['it-change'],
        });
        /** Current image source URL displayed in the avatar */
        this.src = '';
        /** Alt text for the current avatar image */
        this.alt = '';
        /** Size of the avatar. Accepts any BSI avatar size token. */
        this.size = 'xxl';
        /** Accepted file types, e.g. "image/*" */
        this.accept = 'image/*';
        /** If true, the upload button is disabled */
        this.disabled = false;
        this._currentSrc = '';
        /** The currently selected File (null until a new file is chosen). */
        this._currentFile = null;
    }
    connectedCallback() {
        super.connectedCallback?.();
        this._currentSrc = this.src;
    }
    willUpdate(changedProperties) {
        super.willUpdate?.(changedProperties);
        if (changedProperties.has('src') && !this._currentSrc) {
            this._currentSrc = this.src;
        }
        // Keep the displayed validation message in sync with the value here (pre-render) rather
        // than in updated(), so picking/clearing a file refreshes it without scheduling a second
        // render — avoids Lit's "scheduled an update after an update completed" warning. The native
        // `?required` attribute still drives checkValidity()/the constraint bubble. Guarded by
        // `hasUpdated` because `inputElement` only exists once the first render has produced the DOM.
        if (this.hasUpdated &&
            !this.customValidation &&
            (changedProperties.has('_currentFile') || changedProperties.has('_currentSrc'))) {
            const hasValue = Boolean(this._currentFile || this._currentSrc);
            const message = this.required && !hasValue ? this.$t('validityRequired') : '';
            this.inputElement?.setCustomValidity(message);
            this.validationMessage = message;
        }
    }
    _handleFileChange(e) {
        const input = e.target;
        const file = input.files?.[0];
        if (!file)
            return;
        this._currentFile = file;
        const reader = new FileReader();
        reader.onload = (event) => {
            this._currentSrc = event.target?.result;
            this.requestUpdate();
        };
        reader.readAsDataURL(file);
        // Reset the native input
        input.value = '';
        this.dispatchEvent(new CustomEvent('it-change', {
            detail: { file, name: this.name, id: this.id },
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        const labelText = this.$t('upload_avatar_label');
        const fileInputLabel = this.required ? labelText : labelText;
        const overlayText = this.overlayLabel ?? this.$t('upload_avatar_overlay_label');
        // A pre-filled `src` or a freshly selected file both satisfy `required`.
        const hasValue = Boolean(this._currentFile || this._currentSrc);
        const showValidation = this.formControlController.submittedOnce || this.customValidation;
        const isInvalid = showValidation && this.validationMessage.length > 0;
        const feedbackId = `invalid-feedback-${this._id}`;
        return html `
      <div class="avatar-upload-wrapper size-${this.size}">
        <it-avatar
          type="image"
          size="${this.size}"
          src="${ifDefined(this._currentSrc || undefined)}"
          alt="${this.alt}"
          class="avatar-upload"
        ></it-avatar>

        <div class="upload-avatar-container">
          <input
            type="file"
            class="upload-avatar it-form__control"
            id="${this._id}"
            accept="${this.accept}"
            ?disabled="${this.disabled}"
            ?required="${this.required && !hasValue}"
            ?formNoValidate="${this.customValidation}"
            aria-label="${fileInputLabel}"
            aria-required="${this.required ? 'true' : nothing}"
            aria-invalid="${isInvalid ? 'true' : nothing}"
            aria-describedby="${ifDefined(isInvalid ? feedbackId : undefined)}"
            @change="${this._handleFileChange}"
          />
          <label part="overlay-label" for="${this._id}" class="it-upload-avatar-label-container" aria-hidden="true">
            <it-icon name="it-camera" size="sm" color="inverse" aria-hidden="true"></it-icon>
            <span class="it-upload-avatar-label">${overlayText}</span>
          </label>
        </div>

        <div class="avatar-upload-icon" aria-hidden="true">
          <it-icon name="it-camera" size="${this.size === 'xl' ? 'xs' : 'sm'}"></it-icon>
        </div>
      </div>

      <div id="${feedbackId}" class="form-feedback text-danger" role="alert" ?hidden=${!isInvalid}>
        ${isInvalid ? this.validationMessage : nothing}
      </div>
    `;
    }
};
ItUploadAvatar.styles = styles;
ItUploadAvatar.shadowRootOptions = {
    ...FormControl.shadowRootOptions,
    delegatesFocus: true,
};
__decorate([
    query('.it-form__control'),
    __metadata("design:type", HTMLInputElement)
], ItUploadAvatar.prototype, "inputElement", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", Object)
], ItUploadAvatar.prototype, "src", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", Object)
], ItUploadAvatar.prototype, "alt", void 0);
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", String)
], ItUploadAvatar.prototype, "size", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", Object)
], ItUploadAvatar.prototype, "accept", void 0);
__decorate([
    property({ type: String, attribute: 'overlay-label' }),
    __metadata("design:type", String)
], ItUploadAvatar.prototype, "overlayLabel", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItUploadAvatar.prototype, "disabled", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], ItUploadAvatar.prototype, "_currentSrc", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], ItUploadAvatar.prototype, "_currentFile", void 0);
ItUploadAvatar = __decorate([
    customElement('it-upload-avatar')
], ItUploadAvatar);

export { ItUploadAvatar };
//# sourceMappingURL=it-upload-avatar.js.map
